import FuelAnalyticsService from '@/services/fuel-analytics-service';
import clientUtils from '@/utils/clientUtils';

import type { AppAnalyticsState } from './AppAnalytics';

const AppAnalyticsSnowflakeService = () => {
  const getAdditionalWhereClauses = (params: AppAnalyticsState) => {
    let additionalWhereClauses = '';
    additionalWhereClauses += getVideoWhereClause(params);
    additionalWhereClauses += getChannelWhereClause(params);
    return additionalWhereClauses;
  };

  const getVideoWhereClause = (params: AppAnalyticsState) => {
    if (params.selectedItems.length > 0) {
      return `
          AND "video" IN ('${params.selectedItems.map((x) => x.id).join("','")}')`;
    }
    return '';
  };

  const getChannelWhereClause = (params: AppAnalyticsState) => {
    if (params.selectedChannels.length > 0) {
      return `
          AND ("channel" IN ('${params.selectedChannels.map((x) => x.id).join("','")}${params.selectedChannels
          .filter((x) => !clientUtils.isNullOrWhitespace(x.alias))
          .map((x) => x.alias)
          .join("','")}')
            OR "liveChannel" IN ('${params.selectedChannels.map((x) => x.id).join("','")}${params.selectedChannels
          .filter((x) => !clientUtils.isNullOrWhitespace(x.alias))
          .map((x) => x.alias)
          .join("','")}'))`;
    }
    return '';
  };

  const fetchContentAnalytics = async (params: AppAnalyticsState) => {
    let query = `
      SELECT "video",
        count(*) AS "count",
        to_number(sum("params": content.duration), 29, 9) AS "duration",
        CASE "count" WHEN 0 THEN 0 ELSE to_number("duration" / "count", 29, 9) END AS "average"
      FROM ANALYTICS_STAGE.PUBLIC.EVENTS
      WHERE "site" IN(${params.sites.map((site) => `'${site}'`).join(', ')})
        AND "eventtype" = 'watch'
        AND "eventdate" BETWEEN '${params.fromDate}' AND '${params.toDate}'
        AND "video" IS NOT NULL`;

    query += getVideoWhereClause(params);

    query += `
      GROUP BY "video"
      ORDER BY "count" desc;`;

    const queryResults = await FuelAnalyticsService.post('analytics/executequery', {
      provider: 'SnowflakeLegacy',
      query,
    });

    if (queryResults.data) {
      return queryResults.data;
    }
    throw new Error('Failed to fetch analytics data from Snowflake.');
  };
  const fetchLiveChannelAnalytics = async (params: AppAnalyticsState) => {
    let query = `
      SELECT "liveChannel" as "channel",
        count(*) AS "count",
        to_number(sum("params": content.duration), 29, 9) AS "duration",
        CASE "count" WHEN 0 THEN 0 ELSE to_number("duration" / "count", 29, 9) END AS "average"
      FROM ANALYTICS_STAGE.PUBLIC.EVENTS
      WHERE "site" IN(${params.sites.map((site) => `'${site}'`).join(', ')})
        AND "eventtype" = 'liveChannelWatch'
        AND "eventdate" BETWEEN '${params.fromDate}' AND '${params.toDate}'
        AND "liveChannel" IS NOT NULL`;

    query += getChannelWhereClause(params);

    query += `
      GROUP BY "liveChannel"
      ORDER BY "count" desc;`;

    const queryResults = await FuelAnalyticsService.post('analytics/executequery', {
      provider: 'SnowflakeLegacy',
      query,
    });

    if (queryResults.data) {
      return queryResults.data;
    }
    throw new Error('Failed to fetch analytics data from Snowflake.');
  };

  return {
    fetchContentAnalytics,
    fetchLiveChannelAnalytics,
  };
};

export { AppAnalyticsSnowflakeService };
